import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalCloseButton,
    Text,
} from '@chakra-ui/react';
import React from 'react';

export interface InvoicePartSuggestionModalProps {
    isOpen: boolean;
    onClose: () => void;
    suggestedPartNumber: string;
    onAccept: () => void;
}

export default function InvoicePartSuggestionModal(props: InvoicePartSuggestionModalProps) {
    const { isOpen, onClose, suggestedPartNumber, onAccept } = props;
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Part not found in NEX</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="sm" color="gray.600">
                        This part number was not found in the NEX purchase order. A similar part number was found. Did you mean <strong>{suggestedPartNumber}</strong>?
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button size="action" variant="outlineGray" mr={3} onClick={onClose}>Cancel</Button>
                    <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onAccept}>Accept correction</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
